module.exports = __webpack_public_path__ + "static/img/47430.6d11cf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/47430.jpg
// module id = iCrv
// module chunks = 1